/*
  Semelhantes da página do produto (sections/semelhantes-produto.liquid): com a moto do cliente (a última escolhida na
  barra "Minha moto", assets/moto-cliente.js) e o produto servindo nela, esconde os itens que não servem nela
  (dono 30/09). Item sem moto (universal, capacete) fica. Grupo sem item some, com a contagem refeita; sem nenhum
  grupo, a seção some. Sem a moto do cliente, ou com o produto sendo de outra moto, fica tudo.
*/
if (!customElements.get('semelhantes-produto')) {
  customElements.define(
    'semelhantes-produto',
    class SemelhantesProduto extends HTMLElement {
      connectedCallback() {
        let motosProduto;
        try {
          motosProduto = JSON.parse(this.querySelector('script[data-motos-produto]')?.textContent || 'null');
        } catch (erro) {
          return;
        }
        const cliente = window.MotoCliente?.noProduto(motosProduto);
        if (!cliente) return;

        this.querySelectorAll('.semelhantes__item[data-motos]').forEach((item) => {
          let motos = [];
          try {
            motos = JSON.parse(item.dataset.motos);
          } catch (erro) {
            return;
          }
          if (motos.length && !motos.some((id) => cliente.numeros.has(String(id)))) item.hidden = true;
        });

        let visiveis = 0;
        this.querySelectorAll('.semelhantes__grupo').forEach((grupo) => {
          const n = [...grupo.querySelectorAll('.semelhantes__item')].filter((item) => !item.hidden).length;
          grupo.hidden = n === 0;
          visiveis += n;
          if (!n) return;
          const qtd = grupo.querySelector('.semelhantes__qtd');
          if (qtd) qtd.textContent = n;
          const texto = qtd?.nextElementSibling;
          if (texto?.classList.contains('visually-hidden')) texto.textContent = `, ${n} ${n === 1 ? 'produto' : 'produtos'}`;
        });
        if (!visiveis) this.hidden = true;
      }
    }
  );
}
